// Release manifest: the product-side facts that a customer bundle must pin. It is
// generated by the release-tag workflow (which resolves the pushed image digests from
// the central registry) and travels INSIDE the distribution npm package.
//
// `pack` reads the digests from here, so a deploy bundle always references images by
// digest, never by a moving tag — the same release always deploys the same bytes.
import { z } from 'zod';
/** One product image: repository path plus the immutable digest of the released build. */
export const ModuleImageSchema = z.strictObject({
    /** Fully qualified repository path, without tag or digest. */
    image: z.string().min(1),
    digest: z.string().regex(/^sha256:[0-9a-f]{64}$/, 'must be a sha256:<64 hex> digest'),
});
/** Desktop-side pins that are not container images. */
export const DesktopReleaseSchema = z.strictObject({
    /** OpenCode sidecar version the fork is pinned to (fork `constants.json`). */
    openCodeVersion: z.string().min(1),
});
export const ReleaseManifestSchema = z.strictObject({
    /** The product version — identical to the distribution package version. */
    productVersion: z.string().min(1),
    /** Commit the release was built from; the digests were resolved by this SHA. */
    commitSha: z.string().min(1),
    images: z.strictObject({
        'echo-control-plane': ModuleImageSchema,
        'echo-admin-fe': ModuleImageSchema,
        'echo-proxy': ModuleImageSchema,
        /** The sandbox code-executor the desktop's code-executor plugin calls over HTTPS. */
        'code-executor': ModuleImageSchema,
    }),
    desktop: DesktopReleaseSchema,
});
//# sourceMappingURL=release-manifest.js.map